export const ROUTE_NAMES = {
  DASHBOARD: "Dashboard",
  IDENTIFICATION: "Identification",
  COMPLIANCE_REVIEW_SEARCH: "ComplianceReviewSearch",
  COMPLIANCE_REVIEW_DETAILS: "ComplianceReviewDetails",
  SANCTION_DETAILS: "SanctionDetails",
  SANCTION_SEARCH: "SanctionSearch",
  TYPE_GAME: "TypeGame",
  LOGIN: "Login",
  SIGN_IN_CALLBACK: "SignInCallback",
  SILENT_CALLBACK: "SilentCallback",
  SIGN_OUT_CALLBACK: "SignOutCallback",
  STATUS: "Status"
};

export const ROUTE_PATHS = {
  SIGN_IN_CALLBACK: "signin-callback",
  SILENT_CALLBACK: "silent-callback",
  SIGN_OUT_CALLBACK: "signout-callback",
  STATUS: "status"
};

export const CHECK_STATUS = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  UNAVAILABLE: "UNAVAILABLE"
};

export const CHECK_REASON = {
  MISSING_REQUIRED_DOCUMENT_DATA: "MISSING_REQUIRED_DOCUMENT_DATA"
};
